import { customAxios } from '../../common/customAxios';

interface postUserSellTractorInquiriesParams {
  reqBody: {
    userSellTractorId: string;
  };
}

export const postUserSellTractorInquiries = ({ reqBody }: postUserSellTractorInquiriesParams): Promise<void> => {
  return customAxios.post('/user-sell-tractor-inquiries', reqBody);
};
